import { colorSchemeVariable, themeQuartz } from 'ag-grid-community'

// AG Grid theme on the app's tokens (styles.css), so it follows light and
// dark with the rest of the UI. colorSchemeVariable reads
// html[data-ag-theme-mode] (set by /theme.js) for the colours not set here.
export const gridTheme = themeQuartz.withPart(colorSchemeVariable).withParams({
  backgroundColor: 'var(--card)',
  foregroundColor: 'var(--text)',
  headerBackgroundColor: 'var(--bg)',
  headerTextColor: 'var(--sec)',
  borderColor: 'var(--border)',
  rowHoverColor: 'var(--el)',
  accentColor: 'var(--accent)',
  fontFamily: "'IBM Plex Sans', system-ui, -apple-system, 'Segoe UI', sans-serif",
  fontSize: 13,
  headerFontSize: 12,
  spacing: 6,
  wrapperBorderRadius: 8,
})
